import { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import { config, priceFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const CategoryDetail = () => {
  const { id_product_subcategory } = useParams();
  const [subcategory, setSubcategory] = useState(null);
  const [products, setProducts] = useState(null);
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  const navigate = useNavigate();

  useEffect(() => {
    getSubcategory();
  }, []);

  useEffect(() => {
    if (subcategory) {
      getProducts();
    }
  }, [subcategory]);

  const getSubcategory = async () => {
    try {
      const requestSubcategory = {
        "id_product_subcategory": id_product_subcategory
      };
      const fetchSubcategory = await jwtFetch(config.ENDPOINT + 'get/product_subcategory', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestSubcategory)
      });
      const responseSubcategory = await fetchSubcategory.json();
      if (responseSubcategory.status === 200) {
        setSubcategory(responseSubcategory.data[0]);
      } else {
        alert(responseSubcategory.message);
      }
    } catch (error) {
      console.error('Error in getSubcategory:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getProducts = async () => {
    try {
      const requestProducts = {
        "product_subcategory_id": id_product_subcategory
      };
      const fetchProducts = await jwtFetch(config.ENDPOINT + 'get/product', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestProducts)
      });
      const responseProducts = await fetchProducts.json();
      if (responseProducts.status === 200) {
        setProducts([...responseProducts.data].sort((a, b) => (a.product_name || '').localeCompare(b.product_name || '')));
      } else {
        alert(responseProducts.message);
      }
    } catch (error) {
      console.error('Error in getProducts:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  return (
    <div id="subcategory-detail">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="product" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left" /></button> Subcategory Detail</div>
                    {crmUser.user_level === 'Admin' && (
                      <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/product/category/subcategory/edit/' + id_product_subcategory}><i className="bi bi-pencil me-1" /> Edit</button>
                    )}
                  </div>
                  {subcategory ? (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Category</div>
                          <div className="col-md-8">{subcategory.category_name} <a href={"/product/category/detail/" + subcategory.product_category_id}><i className="bi bi-link-45deg" /></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Name</div>
                          <div className="col-md-8">{subcategory.product_subcategory_name}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Status</div>
                          <div className="col-md-8"><span className={"badge bg-" + (subcategory.product_subcategory_status === 'Active' ? 'success' : 'danger')}>{subcategory.product_subcategory_status}</span></div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </section>

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24">Product List</div>
                    {subcategory && crmUser.user_level === 'Admin' && (
                      <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/product/add/category/' + subcategory.product_category_id + '/' + id_product_subcategory}><i className="bi bi-plus-lg me-1" /> Add</button>
                    )}
                  </div>
                  {products && products.length ? (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th className="bg-primary text-light">#</th>
                            <th className="bg-primary text-light">Name</th>
                            <th className="bg-primary text-light">Subcategory</th>
                            <th className="bg-primary text-light">Type</th>
                            <th className="bg-primary text-light text-end">Price</th>
                            <th className="bg-primary text-light text-center">Status</th>
                            <th className="bg-primary"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {products.map((product, p) =>
                            <tr key={"product-" + [p]} onClick={() => window.location.href = '/product/detail/' + product.id_product}>
                              <td valign="middle">{p + 1}</td>
                              <td valign="middle">{product.product_name}</td>
                              <td valign="middle">{product.subcategory_name}</td>
                              <td valign="middle">{product.product_type}</td>
                              <td valign="middle" align="right">{priceFormat(product.product_price, product.product_currency)}</td>
                              <td valign="middle" align="center"><span className={"badge bg-" + (product.product_status === 'Active' ? 'success' : 'danger')}>{product.product_status}</span></td>
                              <td valign="middle" align="right"><button type="button" className="btn btn-icon btn-outline-secondary" aria-label="View product"><i className="bi bi-eye" /></button></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryDetail;


